import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    
    {
        path: "/GuangzhouUnicom1",
        name: "GuangzhouUnicom1",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom1"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom2",
        name: "GuangzhouUnicom2",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom2"),
        },
        meta: {
            title: "广东联通29元流量卡套-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom21",
        name: "GuangzhouUnicom21",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom21"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom3",
        name: "GuangzhouUnicom3",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom3"),
        },
        meta: {
            title: "中国联通29元小骑士卡套餐-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom4",
        name: "GuangzhouUnicom4",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom4"),
        },
        meta: {
            title: "中国联通49元大骑士卡套餐-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom5",
        name: "GuangzhouUnicom5",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom5"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicom6",
        name: "GuangzhouUnicom6",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicom6"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/XianUnicom1",
        name: "XianUnicom1",
        components: {
            default: () =>
                import("@/pages/XianUnicom1"),
        },
        meta: {
            title: "中国联通59元套餐-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ShenzhenUnicom01",
        name: "ShenzhenUnicom01",
        components: {
            default: () =>
                import("@/pages/ShenzhenUnicom01"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ShenzhenUnicomJd01",
        name: "ShenzhenUnicomJd01",
        components: {
            default: () =>
                import("@/pages/ShenzhenUnicomJd01"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ShenzhenUnicomJd02",
        name: "ShenzhenUnicomJd02",
        components: {
            default: () =>
                import("@/pages/ShenzhenUnicomJd02"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicomJd01",
        name: "GuangzhouUnicomJd01",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicomJd01"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouUnicomJd02",
        name: "GuangzhouUnicomJd02",
        components: {
            default: () =>
                import("@/pages/GuangzhouUnicomJd02"),
        },
        meta: {
            title: "中国联通-广州煜萱科技有限公司",
        },
    },
    
    {
        path: "/GuangdongUnicomJC01",
        name: "GuangdongUnicomJC01",
        components: {
            default: () =>
                import("@/pages/GuangdongUnicomJC01"),
        },
        meta: {
            title: "中国联通",
        },
    },
    {
        path: "/BeautifulNumber",
        name: "BeautifulNumber",
        components: {
            default: () =>
                import("@/pages/BeautifulNumber"),
        },
        meta: {
            title: "中国联通",
        },
    },
    {
        path: "/GuangzhouTelecom1",
        name: "GuangzhouTelecom1",
        components: {
            default: () =>
                import("@/pages/GuangzhouTelecom1"),
        },
        meta: {
            title: "中国电信-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouTelecom2",
        name: "GuangzhouTelecom2",
        components: {
            default: () =>
                import("@/pages/GuangzhouTelecom2"),
        },
        meta: {
            title: "广州电信39元套餐-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouTelecomJd",
        name: "GuangzhouTelecomJd",
        components: {
            default: () =>
                import("@/pages/GuangzhouTelecomJd"),
        },
        meta: {
            title: "广州电信39元套餐-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ZhejiangTelecom1",
        name: "ZhejiangTelecom1",
        components: {
            default: () =>
                import("@/pages/ZhejiangTelecom1"),
        },
        meta: {
            title: "浙江电信29元/月大语音卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ZhejiangTelecom2",
        name: "ZhejiangTelecom2",
        components: {
            default: () =>
                import("@/pages/ZhejiangTelecom2"),
        },
        meta: {
            title: "浙江电信大语音卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/TianjinTelecom1",
        name: "TianjinTelecom1",
        components: {
            default: () =>
                import("@/pages/TianjinTelecom1"),
        },
        meta: {
            title: "天津电信49元骑士卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/NingboTelecomJd",
        name: "NingboTelecomJd",
        components: {
            default: () =>
                import("@/pages/NingboTelecomJd"),
        },
        meta: {
            title: "宁波电信39元畅享流量卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/XiamenUnicom",
        name: "XiamenUnicom",
        components: {
            default: () =>
                import("@/pages/XiamenUnicom"),
        },
        meta: {
            title: "中国联通51元2000分钟-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangdongMobileElm39",
        name: "GuangdongMobileElm39",
        components: {
            default: () =>
                import("@/pages/GuangdongMobileElm39"),
        },
        meta: {
            title: "广东移动骑手卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouMobileElm39",
        name: "GuangzhouMobileElm39",
        components: {
            default: () =>
                import("@/pages/GuangzhouMobileElm39"),
        },
        meta: {
            title: "广东移动骑手卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/GuangzhouMobileElm02",
        name: "GuangzhouMobileElm02",
        components: {
            default: () =>
                import("@/pages/GuangzhouMobileElm02"),
        },
        meta: {
            title: "广东移动骑手卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ShenzhenMobileElm39",
        name: "ShenzhenMobileElm39",
        components: {
            default: () =>
                import("@/pages/ShenzhenMobileElm39"),
        },
        meta: {
            title: "广东移动骑手卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/FoshanMobileElm39",
        name: "FoshanMobileElm39",
        components: {
            default: () =>
                import("@/pages/FoshanMobileElm39"),
        },
        meta: {
            title: "广东移动骑手卡-广州煜萱科技有限公司",
        },
    },
    {
        path: "/ShanghaiMobileElm39",
        name: "ShanghaiMobileElm39",
        components: {
            default: () =>
                import("@/pages/ShanghaiMobileElm39"),
        },
        meta: {
            title: "上海移动骑手卡-广州煜萱科技有限公司",
        },
    },
    //江苏移动
    {
        path: "/JiangsuMobileElm01",
        name: "JiangsuMobileElm01",
        components: {
            default: () =>
                import("@/pages/JiangsuMobileElm01"),
        },
        meta: {
            title: "江苏移动骑手卡-广州煜萱科技有限公司",
        },
    },
    //江苏移动2
    {
        path: "/JiangsuMobileElm02",
        name: "JiangsuMobileElm02",
        components: {
            default: () =>
                import("@/pages/JiangsuMobileElm02"),
        },
        meta: {
            title: "江苏移动骑手卡-广州煜萱科技有限公司",
        },
    },
    //北京联通
    {
        path: "/BeijingUnicom01",
        name: "BeijingUnicom01",
        components: {
            default: () =>
                import("@/pages/BeijingUnicom01"),
        },
        meta: {
            title: "中国联通骑士卡-广州煜萱科技有限公司",
        },
    },
    //湖北移动
    {
        path: "/HubeiMobileElm01",
        name: "HubeiMobileElm01",
        components: {
            default: () =>
                import("@/pages/HubeiMobileElm01"),
        },
        meta: {
            title: "武汉骑士卡",
        },
    },
    //河南移动
    {
        path: "/HenanMobileElm01",
        name: "HenanMobileElm01",
        components: {
            default: () =>
                import("@/pages/HenanMobileElm01"),
        },
        meta: {
            title: "河南移动骑士卡-广州煜萱科技有限公司",
        },
    },
    //东莞移动
    {
        path: "/DongguanMobileElm01",
        name: "DongguanMobileElm01",
        components: {
            default: () =>
                import("@/pages/DongguanMobileElm01"),
        },
        meta: {
            title: "东莞移动骑士卡-广州煜萱科技有限公司",
        },
    },
    //佛山联通
    {
        path: "/FoshanUnicomElm01",
        name: "FoshanUnicomElm01",
        components: {
            default: () =>
                import("@/pages/FoshanUnicomElm01"),
        },
        meta: {
            title: "中国联通骑士卡-广州煜萱科技有限公司",
        },
    },
    //  协议页面
    {
        path: "/unicomDeal9",
        name: "unicomDeal9",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal9"),
        },
        meta: {
            title: "入网协议",
        },
    },
    {
        path: "/ysxy",
        name: "ysxy",
        components: {
            default: () =>
                import("@/pages/deal/ysxy"),
        },
        meta: {
            title: "入网协议",
        },
    },
    {
        path: "/unicomDeal1",
        name: "unicomDeal1",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal1"),
        },
        meta: {
            title: "中国联通客户入网服务协议",
        },
    },
    {
        path: "/unicomDeal2",
        name: "unicomDeal2",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal2"),
        },
        meta: {
            title: "中国联通用户隐私政策",
        },
    },
    {
        path: "/unicomDeal3",
        name: "unicomDeal3",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal3"),
        },
        meta: {
            title: "申请使用通信服务涉实名登记及电信网络新型违法犯罪的防范提示及责任告知书",
        },
    },
    {
        path: "/unicomDeal4",
        name: "unicomDeal4",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal4"),
        },
        meta: {
            title: "中国联通儿童个人信息保护政策及监护人须知",
        },
    },
    {
        path: "/unicomDeal5",
        name: "unicomDeal5",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal5"),
        },
        meta: {
            title: "中国联通客户 5G/4G/3G 优惠活动业务协议",
        },
    },
    {
        path: "/unicomDeal6",
        name: "unicomDeal6",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal6"),
        },
        meta: {
            title: "中国联通相关协议",
        },
    },
    {
        path: "/unicomDeal7",
        name: "unicomDeal7",
        components: {
            default: () =>
                import("@/pages/deal/unicomDeal7"),
        },
        meta: {
            title: "重庆骑士卡相关协议",
        },
    },
    //广东移动
    {
        path: "/gdydyhxsxy",
        name: "gdydyhxsxy",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/ydyhxsxy"),
        },
        meta: {
            title: "用户隐私协议",
        },
    },
    {
        path: "/gdydruwangxy",
        name: "gdydruwangxy",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/ydruwangxy"),
        },
        meta: {
            title: "中国移动通信客户服务协议",
        },
    },
    {
        path: "/gddzqdkhfwxy",
        name: "gddzqdkhfwxy",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/yddzqdkhfwxy"),
        },
        meta: {
            title: "中国移动通信客户服务协议",
        },
    },
    {
        path: "/gdyddzqdspxsfwxy",
        name: "gdyddzqdspxsfwxy",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/yddzqdkhfwxy"),
        },
        meta: {
            title: "中国移动广东公司电子渠道商品销售服务协议",
        },
    },
    {
        path: "/gdyddzqdspxsfwxy2",
        name: "gdyddzqdspxsfwxy2",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/yddzqdkhfwxy2"),
        },
        meta: {
            title: "中国移动广东公司电子渠道商品销售服务协议",
        },
    },
    {
        path: "/gdydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs",
        name: "gdydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/ydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs"),
        },
        meta: {
            title: "个人/单位在通信企业申请通讯工具涉电信网络新型违法犯罪法律责任及防范提示告知书",
        },
    },
    {
        path: "/gdydqycsfwxy",
        name: "gdydqycsfwxy",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/ydqycsfwxy"),
        },
        meta: {
            title: "中国移动权益超市服务协议",
        },
    },
    {
        path: "/gdydjytk",
        name: "gdydjytk",
        components: {
            default: () =>
                import("@/pages/deal/mobile/gd/ydjytk"),
        },
        meta: {
            title: "解约条款",
        },
    },
    {
        path: "/noOrder",
        name: "noOrder",
        components: {
            default: () =>
                import("@/pages/noOrder"),
        },
        meta: {
            title: "订单查询",
        },
    },
    {
        path: "/notData",
        name: "notData",
        components: {
            default: () =>
                import("@/pages/notData"),
        },
        meta: {
            title: "错误",
        },
    },
    {
        path: '/order/list',
        name: 'OrderList',
        component: () => import('@/pages/OrderList'),
        meta: {
            title: '订单列表'
        }
    },
    {
        path: '/order/list-local',
        name: 'OrderListLocal',
        component: () => import('@/pages/OrderListLocal'),
        meta: {
            title: '订单查询'
        }
    },
    {
        path: '/GuangzhouTelecomAd',
        name: 'GuangzhouTelecomAd',
        components: {
            default: () =>
                import("@/pages/gzdxAd/GuangzhouTelecomAd"),
        },
        meta: {
            title: "YX-广州电信活动",
        },
    },
    {
        path: "/zgdxkd",
        name: "zgdxkd",
        components: {
            default: () =>
            import("@/pages/ad/zgdxkd"),
        },
        meta: {
            title: "中国电信宽带预约-广州煜萱科技有限公司",
        },
    },
    //饿了么骑手校验
    {
        path: "/ElemeRiderCheck",
        name: "ElemeRiderCheck",
        components: {
            default: () =>
                import("@/pages/ElemeRiderCheck"),
        },
        meta: {
            title: "骑士卡",
        },
    },
    //口令自助查询（企业微信欢迎语/快捷回复入口）
    {
        path: "/RiderPwdQuery",
        name: "RiderPwdQuery",
        components: {
            default: () =>
                import("@/pages/RiderPwdQuery"),
        },
        meta: {
            title: "口令查询",
        },
    },
];

const router = new VueRouter({
    routes,
});

export default router;
